import { commonUtil } from '@/util'

const request = {}

request.createRequest = function ({
  clientData,
  registerProductList,
  totalList,
  privateRemarks,
  clientRemarks,
  beforeOrderEditHistoryId
}) {
  // 選択商品情報
  const tmpProductList = registerProductList.map((ele) => {
    return {
      productId: ele.productId,
      quantity: ele.count,
      price: ele.price,
      disabledFlg: ele.disabledFlg
    }
  })
  return {
    // 仕入先情報
    orderSupplierName: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.supplierName
    ),
    orderPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.phone.countryCode.value
    ),
    orderPhoneNumber: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.phone.phoneNumber
    ),
    orderFaxNumberCountryId: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.fax.countryCode.value
    ),
    orderFaxNumber: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.fax.phoneNumber
    ),
    orderAddressCountryId: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.country.value
    ),
    orderPostalCode: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.postalCode
    ),
    orderRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.invoiceInfo.region, true)
    ),
    orderRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.invoiceInfo.region, false)
    ),
    orderAddress1: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.address1
    ),
    orderAddress2: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.address2
    ),
    orderEmail: commonUtil.nullEmptyFormatNull(clientData.invoiceInfo.email),
    orderSection: commonUtil.nullEmptyFormatNull(
      clientData.invoiceInfo.section
    ),
    orderRep: commonUtil.nullEmptyFormatNull(clientData.invoiceInfo.rep),

    // 希望入庫場所
    preferredAddressCountryId: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.country.value
    ),
    preferredPostalCode: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.postalCode
    ),
    preferredRegionId: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.receiverInfo.region, true)
    ),
    preferredRegion: commonUtil.nullEmptyFormatNull(
      commonUtil.formatRegion(clientData.receiverInfo.region, false)
    ),
    preferredAddress1: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.address1
    ),
    preferredAddress2: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.address2
    ),
    preferredPhoneNumberCountryId: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.phone.countryCode.value
    ),
    preferredPhoneNumber: commonUtil.nullEmptyFormatNull(
      clientData.receiverInfo.phone.phoneNumber
    ),

    // 発注情報
    currencyId: clientData.orderInfo.currency.value,
    orderDate: clientData.orderInfo.orderDate,
    preferredDate: commonUtil.nullEmptyFormatNull(
      clientData.orderInfo.deliveryDate
    ),

    // フッター
    consumptionTax10: String(
      commonUtil.nullEmptyFormat(totalList.tax10.tax, 0)
    ),
    consumptionTax8: String(commonUtil.nullEmptyFormat(totalList.tax8.tax, 0)),
    discount: String(commonUtil.nullEmptyFormat(totalList.discount, 0)),
    comission: String(commonUtil.nullEmptyFormat(totalList.shipping, 0)),

    // 商品
    productList: tmpProductList,

    beforeOrderEditHistoryId: commonUtil.nullEmptyFormatNull(
      beforeOrderEditHistoryId
    )
  }
}
export default { request }
